import SentryReporting from '@/services/SentryReporting';
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';
import IdentityForm from './Components/Legal/IdentityForm.vue';
import PaymentForm from './Components/Legal/PaymentForm.vue';
import ConfirmationForm from './Components/Legal/ConfirmationForm.vue';
import TurnoverForm from './Components/Legal/TurnoverForm.vue';
import BeneficiaryForm from './Components/Legal/BeneficiaryForm.vue';
import ShareholdersForm from './Components/Legal/ShareholdersForm.vue';
import FinanceForm from './Components/Legal/FinanceForm.vue';
import EntityRegistrationForm from './Components/Legal/EntityRegistrationForm.vue';
import ManagerRegistrationForm from './Components/Legal/ManagerRegistrationForm.vue';
import ClientRegistrationForm from './Components/Legal/ClientRegistrationForm.vue';
import AuthenticationForm from './Components/Legal/AuthenticationForm.vue';
import Vue from 'vue';
import { registerSharedComponents } from './shared-vue-components';
import http from './utilities/axios';
import { getBody, getMetaValue, onDomReady } from './utilities/browser';
import './cookies';
import initSession from './session.js';

const sentryDsn = getMetaValue('sentry-vue-dsn');
if (sentryDsn) {
    const sentryRelease = getMetaValue('sentry-vue-release') || '1.0.0';
    Sentry.init({
        Vue,
        release: sentryRelease,
        dsn: sentryDsn,
        integrations: [new Integrations.BrowserTracing()],
    });
}

Vue.prototype.$http = http;
Vue.prototype.$sentyReporting = new SentryReporting();

registerSharedComponents(Vue);
Vue.component('cc-authentication-form', AuthenticationForm);
Vue.component('cc-client-registration-form', ClientRegistrationForm);
Vue.component('cc-manager-registration-form', ManagerRegistrationForm);
Vue.component('cc-entity-registration-form', EntityRegistrationForm);
Vue.component('cc-turnover-form', TurnoverForm);
Vue.component('cc-finance-form', FinanceForm);
Vue.component('cc-shareholders-form', ShareholdersForm);
Vue.component('cc-beneficiary-form', BeneficiaryForm);
Vue.component('cc-confirmation-form', ConfirmationForm);
Vue.component('cc-payment-form', PaymentForm);
Vue.component('cc-identity-form', IdentityForm);

onDomReady(() => {
    setTimeout(() => {
        const w = parseFloat(getComputedStyle(getBody(), null).width.replace('px', ''));
        if (w < 991 && location.pathname.substring(1).length > 0) {
            location.href = '#app';
        }
    }, 300);

    // eslint-disable-next-line no-new
    new Vue({
        el: '#app',
    });

    initSession();
});

